import { extractCriticalStyles } from './extract-critical-styles.js';
/**
 * Used for SSR (server-side rendering), renders a static `<style>` tag as a
 * string with all of the "critical styles" (i.e. the styles required by the
 * HTML snippet) for the server-side rendered page.
 *
 * This can be used in conjunction with a webserver (like Express) to insert the
 * generated `<style>` tag into the `<head>` of an HTML document.
 */
export function renderStylesToString(html, { nonce } = {}) {
    const { key, ids, css } = extractCriticalStyles(html);
    const nonceSnippet = nonce ? `nonce="${nonce}" ` : ``;
    return `<style ${nonceSnippet}data-emotion="${key} ${ids.join(' ')}">${css}</style>`;
}
//# sourceMappingURL=render-styles-to-string.js.map